export default __webpack_public_path__ + "static/media/img_baseCottonEars_cotton.e51ece2b.jpg";